import { configureStore } from '@reduxjs/toolkit'
import authReducer from './slices/authSlice'
import attendanceReducer from './slices/attendanceSlice'
import employeeReducer from './slices/employeeSlice'
import leaveReducer from './slices/leaveSlice'
import payrollReducer from './slices/payrollSlice'
import dashboardReducer from './slices/dashboardSlice'
import overtimeReducer from './slices/overtimeSlice'
import expenseReducer from './slices/expenseSlice'
import notificationReducer from './slices/notificationSlice'
import subscriptionReducer from './slices/subscriptionSlice'

export const store = configureStore({
  reducer: {
    auth: authReducer,
    attendance: attendanceReducer,
    employee: employeeReducer,
    leave: leaveReducer,
    payroll: payrollReducer,
    dashboard: dashboardReducer,
    overtime: overtimeReducer,
    expense: expenseReducer,
    notification: notificationReducer,
    subscription: subscriptionReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
})
